module.exports = __webpack_public_path__ + "img/tips1_botlist2img1.43277ed2.jpg";